module.exports = __webpack_public_path__ + "static/portfolio-6-da31ff456d98ffe26a58aed99af725bc.jpg";